import { Users } from "lucide-react";
import { isReconciliationEnabled } from "@/lib/featureFlags";
import { EntityLink, EntityLinkPlain } from "./EntityLink";

/**
 * DebtorAccountLink — canonical family/account rendering, e.g. "Family Dhar / Kos",
 * deep-linking to the reconciliation debtor-account detail
 * (`/billing/reconciliation?tab=debtor-accounts&debtor=`). Falls back to plain
 * text when `debtorId` is missing or reconciliation is off: its routes are then not
 * mounted and a link would land on NotFound (#1878). The flag is read at render, not
 * from the `FEATURE_FLAGS` snapshot, so tests can stub it per case.
 */
export interface DebtorAccountLinkProps {
  debtorId?: string | null;
  displayName?: string | null;
  className?: string;
  "data-testid"?: string;
}

export function DebtorAccountLink({
  debtorId,
  displayName,
  className,
  "data-testid": dataTestId,
}: DebtorAccountLinkProps) {
  const label = displayName && displayName.length > 0 ? displayName : "—";
  if (!debtorId || !isReconciliationEnabled()) {
    return (
      <EntityLinkPlain
        icon={Users}
        title={label}
        className={className}
        data-testid={dataTestId}
      >
        {label}
      </EntityLinkPlain>
    );
  }
  return (
    <EntityLink
      to={`/billing/reconciliation?tab=debtor-accounts&debtor=${encodeURIComponent(debtorId)}`}
      icon={Users}
      title={label}
      className={className}
      data-testid={dataTestId}
    >
      {label}
    </EntityLink>
  );
}
